/* eslint-disable no-unused-vars */
import {
    Component, Mixins,
} from 'vue-property-decorator';
import Classes from '@components/shared/mixins/classes';
import * as mdi from '@mdi/js';
import SvgIcon from '@jamescoyle/vue-icon/lib/svg-icon.vue';
import config from '@components/shared/config';
import Props from './props';

/**
 * @name Icon
 */
@Component({
    components: {
        SvgIcon,
    },
})
class YIcon extends Mixins(Props, Classes) {
    /**
     * All icons in MaterialDesignIcons
     */
    mdi = mdi;

    /**
     * Props list that active by developer
     */
    activeCommonProps: Array<string> = ['color', 'size', 'icon'];

    /**
     * Create Common Props for the icon.
     * 
     * @returns {object} - List of props
     */
    get commonProps(): Record<string, any> { // eslint-disable-line @typescript-eslint/no-explicit-any
        const commonProps: Record<string, any> = { // eslint-disable-line @typescript-eslint/no-explicit-any
            baseClass: this.baseClass,
        };
        this.activeCommonProps.forEach((item) => {
            commonProps[item] = this[item];
        });
        return commonProps;
    }

    /**
     * Return icon name.
     * 
     * @returns {string} - Icon name
     */
    get iconName(): string {
        let { icon } = this;
        if (this.library === 'mdi') {
            icon = icon.replace(/-\w/g, (text) => text.replace(/-/, '').toUpperCase());
        }
        return icon;
    }

    /**
     * Create classes array for the icon.
     * 
     * @returns {Array} - Array of classes
     */
    get classes(): Array<string> {
        const cls: Array<string> = [];
        cls.push(...this.commonClasses('Icon', this.commonProps, this.baseClass || config.prefix.icon));
        cls.push(this.library);
        cls.push(this.icon);
        if (this.inner) {
            cls.push('is-inner');
        }

        // Remove 'is-icon' from classes
        cls.splice(cls.findIndex((item) => item === 'is-icon'), 1);
        return cls;
    }
}

export default YIcon;
